import React, { useEffect } from 'react';
import { useParams, ScrollRestoration } from 'react-router-dom';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import { useContext } from 'components/Members/Programs/Views/Show/Context';
import SavedForLater from './SavedForLater';
import RegularProgram from './RegularProgram';

export default function Index() {
  const { programId } = useParams();

  const { dispatch, actions, state } = useContext();

  useEffect(() => {
    actions.load(dispatch, programId);
  }, [programId]);

  useEffect(() => {
    if (state.program) {
      document.title = state.program.attributes.title;
    }
  }, [state.program]);

  if (state.program === null) {
    return (
      <div className="content">
        <section>
          <LoadingPlaceholder text="Loading..." />
        </section>
      </div>
    );
  }

  if (state.program.attributes.status === 'saved_for_later') {
    return (
      <>
        <SavedForLater program={state.program} />
        <ScrollRestoration />
      </>
    );
  }

  return (
    <>
      <RegularProgram program={state.program} />
      <ScrollRestoration />
    </>
  );
}
